import { Button, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutDemoMovableResizableModalDialog extends Layout {
    buttonTryItModal: Button;
    buttonTryItMovable: Button;
    buttonTryItNotModal: Button;
    buttonTryItNotMovable: Button;
    buttonTryItNotResizable: Button;
    buttonTryItResizable: Button;
    labelCodeModal: Label;
    labelCodeMovable: Label;
    labelCodeNotModal: Label;
    labelCodeNotMovable: Label;
    labelCodeNotResizable: Label;
    labelCodeResizable: Label;
    labelDescrModal: Label;
    labelDescrMovable: Label;
    labelDescrNotModal: Label;
    labelDescrNotMovable: Label;
    labelDescrNotResizable: Label;
    labelDescrResizable: Label;
    labelHeadingModal: Label;
    labelHeadingMovable: Label;
    labelHeadingResizable: Label;
    panelButtonModal: Panel;
    panelButtonMovable: Panel;
    panelButtonNotModal: Panel;
    panelButtonNotMovable: Panel;
    panelButtonNotResizable: Panel;
    panelButtonResizable: Panel;
    panelCodeModal: Panel;
    panelCodeMovable: Panel;
    panelCodeNotModal: Panel;
    panelCodeNotMovable: Panel;
    panelCodeNotResizable: Panel;
    panelCodeResizable: Panel;
    panelIsModal: Panel;
    panelIsMovable: Panel;
    panelIsResizable: Panel;
    panelModal: Panel;
    panelMovable: Panel;
    panelNotModal: Panel;
    panelNotMovable: Panel;
    panelNotResizable: Panel;
    panelResizable: Panel;
}
